<template>
    <div>
        <p>Desarrollado por <a
                href="https://github.com/danield413"
                target="_blank">Daniel Díaz</a></p>
    </div>
</template>

<style scoped>
div {
    position: fixed;
    bottom: 40px;
    left: 10px;
    background-color: #000;
    padding: 5px;
    border-radius: 5px;
    display: grid;
    place-content: center;
    height: 40px;
    width: 210px;
}

a {
    text-decoration: none;
    color: #00FF83;
    font-weight: bold;
    border-bottom: 1px solid #00FF83;
}

p {
    font-size: 13px;
    color: white;
    text-align: center;
    margin-bottom: 0;
}
</style>